import { render, staticRenderFns } from "./DriverProjects.vue?vue&type=template&id=742dc2c0&scoped=true&"
import script from "./DriverProjects.vue?vue&type=script&lang=js&"
export * from "./DriverProjects.vue?vue&type=script&lang=js&"
import style0 from "./DriverProjects.vue?vue&type=style&index=0&id=742dc2c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742dc2c0",
  null
  
)

export default component.exports